<template>
  <div class="column flex mt-5 registration-padding" :class="{ mobile: $vuetify.breakpoint.smAndDown }">
    <div class="column flex relative" style="max-width: 840px">
      <!-- Documents of enrollment -->
      <div>
        <div class="row align-center tournament-light-blue--text title" style="height: 36px">
          Documentos necessários
        </div>

        <div class="row mb-2">
          É necessário enviar o documento de identidade (RG/CNH)<span v-if="community != 'desafiorelampago'">,
            <a :href="imageAuthorizationURL" target="_blank" class="mx-1">autorização de uso de imagem</a>
            e o
            <a :href="statementResponsabilityURL" target="_blank" class="mx-1">termo de responsabilidade</a></span>
        </div>

        <div v-loading="uploading" class="tournament-light-grey rounded pa-4 column"
          element-loading-text="Carregando...">
          <div class="column" :class="model.documents.permissions && model.documents.permissions.length
            ? 'mb-3'
            : ''
            ">
            <QueuedUploadList ref="uploader" v-model="model.documents.permissions" class="row wrap"
              style="flex-wrap: wrap; justify-content: space-between"
              upload-class="py-2 pl-3 pr-2 my-2 white elevate-2 ra-1" upload-style="width: calc(50% - 8px);"
              :limit="3" />
          </div>
        </div>
      </div>

      <div class="mt-4 pt-2">
        <div class="row align-center tournament-light-blue--text title" style="height: 36px">
          Áreas de Interesse
        </div>

        <div class="tournament-light-grey rounded pa-4 column">
          <v-select v-model="model.judge.area" color="tournament-black" class="pl-2 tournament-black--text"
            :items="judgeKinds" label="Áreas de Interesse" item-text="title" item-value="_id" multiple />
        </div>
      </div>

      <div v-if="model && model.documents.acceptRules" class="row align-center mt-4" style="height: 36px">
        <v-checkbox v-model="model.documents.acceptRules._id" class="no-flex pa-0 mt-0" value="true"
          style="height: 24px" color="tournament-green" />
        <div class="ml-2 tournament-dark-blue--text column flex">
          <div class="row">
            <div class="row mr-2">
              Declaro estar ciente das
              <a class="tournament-light-blue--text underline ml-1" :href="season.acceptRules" target="_blank">Regras da
                {{ season.name }} - {{ season.year }}</a>
            </div>
          </div>
        </div>
      </div>

      <div class="row align-right mb-3 mt-4">
        <v-spacer />
        <el-button :loading="isUploading" class="tournament-green tournament-white--text align-end rounded no-border"
          @click.native="emitJudgeInfo()">
          CONTINUAR
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import { mapState } from "vuex";

import getJudgeTypes from "@/helpers/events/getJudgeTypes";

import QueuedUploadList from "@/components/QueuedUploadList";
import getCurrentSeason from "@/helpers/events/getCurrentSeason";

export default {
  name: "EventKind",

  components: {
    QueuedUploadList,
  },

  props: {},
  data() {
    return {
      model: {
        judge: {
          area: [],
        },
        documents: {
          permissions: [],
          acceptRules: {},
        },
      },
      uploading: false,
    };
  },

  computed: {
    ...mapState(["community"]),

    season() {
      return getCurrentSeason(this.community);
    },

    judgeKinds() {
      return getJudgeTypes(this.community).map((judgeType) => ({
        ...judgeType,
        active: true,
        kind: judgeType._id,
        title: judgeType.label,
      }));
    },

    isUploading() {
      return this.model.documents.permissions.some(
        (up) => up.$upload && up.$upload.running,
      );
    },

    imageAuthorizationURL() {
      return {
        "fll-brasil": "https://layers.land/fll-juiz",
        "ftc-brasil": "https://layers.land/ftc-juiz-imagem",
        "f1-brasil": "https://layers.land/f1-juiz-imagem",
        "frc-brasil": "https://layers.land/frc-juiz",
        desafiocovid:
          "https://cdn.layers.digital/admin/uploads/fb077c87-a18a-4c96-ad1a-5afb21a23e50/termo_de_imagem.pdf",
        "off-season-sesi-mt": "https://layers.land/fll-juiz"
      }[this.community];
    },

    statementResponsabilityURL() {
      return {
        "fll-brasil": "https://layers.land/fll-juiz",
        "ftc-brasil": "https://layers.land/ftc-juiz-adesao",
        "f1-brasil": "https://layers.land/f1-juiz-adesao",
        "frc-brasil": "https://layers.land/frc-juiz",
        desafiocovid:
          "https://cdn.layers.digital/admin/uploads/f43eb96b-46aa-4e57-b476-3ff118921109/termo_autorizacao_tecnico.pdf",
        "off-season-sesi-mt": "https://layers.land/fll-juiz",
      }[this.community];
    },
  },

  methods: {
    emitJudgeInfo() {
      if (
        this.community != "desafiocovid" &&
        this.community != "desafiorelampago"
      ) {
        const documentsNumber = _.get(
          this.model.documents.permissions,
          "length",
        );
        if (!documentsNumber) {
          return this.$notify.error({
            title: this.$t("general.error"),
            message: this.$t("registration.error.send_documents"),
          });
        }
      }

      const selectArea = _.get(this.model.judge.area, "length");
      if (!selectArea) {
        return this.$notify.error({
          title: this.$t("general.error"),
          message: this.$t("registration.error.select_area"),
        });
      }

      const confirmed = _.get(this.model.documents.acceptRules, "_id", null);
      if (!confirmed) {
        return this.$notify.error({
          title: this.$t("general.error"),
          message: this.$t("registration.error.confirm_rules"),
        });
      }

      this.$emit("emitJudgeInfo", this.model);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/Registration/Steps/Judge.vue